import initializeUploadDropArea from 'upload';
import initializeBoardPriceCalculator from 'board_price_calculator';

window.addEventListener('load', () => {
  initializeUploadDropArea();
  initializeBoardPriceCalculator();
});
